export default "__VITE_ASSET__DU1njlx5__"